import VueGtag from 'vue-gtag-next'

const gTagId = process.env.VUE_APP_GTAG_ID

export function useGTag (app, userId) {
  if (!gTagId) {
    return
  }

  app.use(VueGtag, {
    property: {
      id: gTagId,
      params: {
        user_id: userId
      }
    }
  })
}
